import { editableTracks } from '@/state/classSession';

/** Return every editable clip id in an arrangement as a fresh selection set. */
export const selectAllClipIds = (tracks = []) => new Set(
  editableTracks(tracks).flatMap((track) => (track.clips || []).map((clip) => clip.id)),
);

export const deleteSelectedEditableClips = (tracks = [], selectedIds = new Set()) => tracks.map((track) => (
  track.inBank ? track : { ...track, clips: (track.clips || []).filter((clip) => !selectedIds.has(clip.id)) }
));

export default selectAllClipIds;
